import LockHalfGrid from './lock_half_grid_section'
import LockHalfGridInline from './lock_half_grid_inline'

export default {
  lock_half_grid: LockHalfGrid,
  lock_half_grid_inline: LockHalfGridInline,
}
